import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import axios from "axios"
// @mui
import { styled } from '@mui/material/styles';
// component
import UpdatePayment from "../components/Create_Group/UpdatePayment";

// @mui

// ----------------------------------------------------------------------


const Div = styled('div')(({ theme }) => ({
  padding : '80px 10%',
  backgroundColor:'#f5f5f5',
  display:'flex',
  flex:1,

}));

// ----------------------------------------------------------------------

export default function LicenseUpgrade() {

  const navigate = useNavigate();
  const gotoLicencePage = () => {
    navigate('/license', { replace: true })
  }

  
  // 컴포넌트 활성화 --------------------------------------------------

  // NEXT
  const [ namePage, activeNamePage ] = useState(true);
  const [ paymentPage, activePaymentPage ] = useState(false);

  // PRE
  const CancelWrite = (x) => {
    activePaymentPage(x);
    activeNamePage(true);

  }
 

  // ----------------------------------------------------------------

 
  return (
    <>
      <Helmet>
        <title> 라이센스 등록 | RainDrop </title>
      </Helmet>

      <Div>
        <UpdatePayment parentFunction={CancelWrite}/>
      </Div>


    </>
  );
}
